import { render, staticRenderFns } from "./ResendInputModal.vue?vue&type=template&id=13e5679f&lang=pug"
import script from "./ResendInputModal.vue?vue&type=script&lang=ts"
export * from "./ResendInputModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports